export default "__VITE_ASSET__Bk$r$OgK__"